/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const updateAlbumNameModelSchema = z.object({
    "name": z.string().max(50).describe("Название")
    })